import { StyleSheet } from '@react-pdf/renderer';

/**
 * Centralized PDF styles for all print documents
 * Used by PDFDocument, MultiPDFDocument, EpaysageAltPDFDocument, etc.
 */
export const pdfStyles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 10,
    fontFamily: 'Helvetica',
    backgroundColor: '#ffffff',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 5,
  },
  logo: {
    width: 100,
    height: 100
  },
  logoSmall: {
    width: 130,
    height: 130,

  },
  logoPlaceholder: {
    width: 80,
    height: 80,
    backgroundColor: '#f3f4f6',
    border: '1pt solid #d1d5db',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  headerInfo: {
    fontSize: 9,
    flex: 1,
    marginLeft: 20,
  },
  headerInfoNoMargin: {
    fontSize: 9,
  },
  headerTitle: {
    fontSize: 10,
    fontWeight: 'bold',
    marginBottom: 5,
    color: '#4E5155',
  },
  headerText: {
    marginBottom: 3,
    color: '#374151',
    fontSize: 9,
  },
  headerTextBold: {
    marginBottom: 3,
    fontSize: 9,
    fontWeight: 'bold',
    color: '#4E5155',
  },
  sectionHeaderPrimary: {
    backgroundColor: '#22c55e',
    color: '#ffffff',
    padding: 4,
    textAlign: 'center',
    fontSize: 10,
    fontWeight: 'bold',
    marginBottom: 5,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
  },
  sectionHeaderAlignement: {
    backgroundColor: '#4682B4',
    color: '#ffffff',
    padding: 4,
    textAlign: 'center',
    fontSize: 10,
    fontWeight: 'bold',
    marginBottom: 5,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
  },
  sectionHeaderEpaysage: {
    backgroundColor: '#964B00',
    color: '#ffffff',
    padding: 4,
    textAlign: 'center',
    fontSize: 10,
    fontWeight: 'bold',
    marginBottom: 5,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
  },
  sectionHeader: {
    backgroundColor: '#6b7280',
    color: '#ffffff',
    padding: 4,
    fontSize: 10,
    fontWeight: 'bold',
    marginBottom: 5,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    textAlign: 'center',
  },
  grid4: {
    flexDirection: 'row',
    gap: 10,
    marginBottom: 10,
    paddingVertical: 10,

  },
  grid3: {
    flexDirection: 'row',
    gap: 15,
    marginBottom: 10,
    paddingVertical: 5,
  },
  grid2: {
    flexDirection: 'row',
    gap: 10,
    marginBottom: 10,
    paddingVertical: 5,
  },
  column: {
    flex: 1,
    paddingLeft: 8,
    borderLeft: '1pt solid gray',
  },
  columnNoLeft: {
    flex: 1,
  },
  infoField: {
    marginBottom: 4,
    paddingVertical: 2,
  },
  infoFieldRow: {
    flexDirection: 'row',
    display: 'flex',
    marginBottom: 4,
    paddingVertical: 2,
    alignItems: 'center',
  },
  infoLabel: {
    fontWeight: 'bold',
    color: '#1f2937',
    fontSize: 8,
  },
  infoValue: {
    color: '#111827',
    fontSize: 8,
  },
  riskIndicator: {
    width: 40,
    height: 12,
    marginTop: 4,
  },
  riskIndicatorSmall: {
    width: 40,
    height: 12,
    marginLeft: 5,
  },
  riskLow: {
    backgroundColor: '#10b981',
  },
  riskModerate: {
    backgroundColor: '#facc15',
  },
  riskHigh: {
    backgroundColor: '#ef4444',
  },
  riskImminent: {
    backgroundColor: '#000000',
  },
  photoContainer: {
    width: 100,
    height: 150,
    justifyContent: 'center',
    alignItems: 'center',
  },
  photoContainerSmall: {
    width: 160,
    height: 120,
    marginBottom: 10,
    border: '1pt solid #d1d5db',
  },
  photo: {
    width: 100,
    height: 150,
    objectFit: 'cover',
  },
  photoSmall: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  photoTitle: {
    fontWeight: 'bold',
    marginBottom: 5,
    fontSize: 9,
  },
  photoPlaceholder: {
    fontSize: 8,
    color: '#6b7280',
  },
  riskEvaluation: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8,
    gap: 5,
  },
  riskEvalTitle: {
    fontSize: 9,
    fontWeight: 'bold',
    color: '#1f2937',
  },
  riskBar: {
    flexDirection: 'row',
    gap: 2,
  },
  riskBarItemContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    border: '1pt solid #d1d5db',
    margin: 0,
    padding: 0,
  },
  riskBarItem: {
    width: 70,
    height: 15,
  },
  riskLabels: {
    flexDirection: 'row',
    marginLeft: 100,
    marginBottom: 8,
    gap: 2,
  },
  riskLabel: {
    fontSize: 7,
    textAlign: 'center',
    color: '#000',
  },
  bevaBox: {
    border: '1pt solid #9ca3af',
    padding: 5,
    fontSize: 10,
  },
  comments: {
    marginTop: 15,
    fontSize: 9,
  },
  commentsWithBorder: {
    marginTop: 10,
    fontSize: 9,
    paddingTop: 5,
    borderTop: '1pt solid #d1d5db',
  },
  commentsLabel: {
    fontWeight: 'bold',
    marginRight: 10,
    marginBottom: 3,
  },
  commentsValue: {
    color: '#4b5563',
    borderBottom: '1pt solid #d1d5db',
    paddingBottom: 5,
    marginTop: 5,
  },
  commentsValueNoBorder: {
    color: '#4b5563',
  },
  treeRiskItem: {
    marginBottom: 6,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  treeRiskBar: {
    width: 50,
    height: 10,
  },
  treeRiskText: {
    fontSize: 8,
    color: '#374151',
    flex: 1,
  },
  treeRiskLabelBold: {
    fontWeight: 'bold',
  },
  treeVisualization: {
    position: 'relative',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  treeImageLayer: {
    position: 'absolute',
    width: '60%',
    height: '50%',
    objectFit: 'contain',
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#f3f4f6',
    borderBottom: '1pt solid #d1d5db',
    paddingVertical: 6,
    paddingHorizontal: 8,
  },
  tableHeaderCell: {
    padding: 5,
    fontWeight: 'bold',
    borderRight: '1px solid #e5e7eb',
    fontSize: 9,
    color: '#4E5155',
  },
  tableRow: {
    flexDirection: 'row',
    borderTop: '1px solid #e5e7eb',
  },
  tableCell: {
    padding: 5,
    borderRight: '1px solid #e5e7eb',
    fontSize: 10,
  },
  tableCellLast: {
    padding: 5,
    fontSize: 8,
  },
  tableCellLabel: {
    fontWeight: 'bold',
    fontSize: 9,
  },
  riskColumn: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  table: {
    border: '1pt solid #d1d5db',
    marginBottom: 15,
  },
  infoBoxHeader: {
    backgroundColor: '#f3f4f6',
    padding: 5,
    fontWeight: 'bold',
    fontSize: 8,
    borderBottom: '1px solid #e5e7eb',
  },
  twoColGrid: {
    flexDirection: 'row',
    gap: 10,
    marginTop: 15,
  },
  infoBox: {
    flex: 1,
    border: '1pt solid #d1d5db',
    padding: 8,
  },
  infoBoxRow: {
    flexDirection: 'row',
    paddingVertical: 4,
    borderBottom: '1pt solid #e5e7eb',
  },
  infoBoxCell: {
    flex: 1,
    fontSize: 9,
    color: '#374151',
  },
  infoBoxCellLast: {
    flex: 1,
    fontSize: 9,
    color: '#111827',
    textAlign: 'right',
  },
  infoBoxCellBold: {
    flex: 1,
    fontSize: 9,
    fontWeight: 'bold',
    color: '#1f2937',
  },
  stateTable: {
    width: '100%',
  },
  stateTableCell: {
    padding: 8,
    borderBottom: '1pt solid #9ca3af',
    fontSize: 8,
  },
  stateTableCellBold: {
    padding: 8,
    fontSize: 8,
    fontWeight: 'bold',
    color: '#4E5155',
  },
  stateTableCellValue: {
    padding: 8,
    borderLeft: '1pt solid #9ca3af',
    fontSize: 8,
  },
  stateTableCellValueLast: {
    padding: 8,
    borderLeft: '1pt solid #9ca3af',
    fontSize: 10,
  },
  commentSection: {
    marginTop: 15,
    paddingTop: 10,
    borderTop: '1pt solid #d1d5db',
  },
  label: {
    fontSize: 9,
    fontWeight: 'bold',
    color: '#1f2937',
  },
  travauxTitle: {
    fontSize: 11,
    fontWeight: 'bold',
    color: '#1f2937',
    marginTop: 10,
    marginBottom: 5,
  },
});
